import { PostRequest } from "./RequestTemplates";

export const validateIban = async (iban: string) => {
  return PostRequest(`${process.env.API_SERVER_URL}/bank-service/iban/validate`, { iban });
};
